import apiMiddleware from "../api/apiMiddleware";

export const getSupplierPlatformTerms = async () => {
  const response = await apiMiddleware.get("/supplier/platform-terms");
  return response.data;
};

export const acceptSupplierPlatformTerms = async () => {
  const response = await apiMiddleware.post("/supplier/platform-terms/accept");
  return response.data;
};
